import React from "react";
import cn from "classnames";
import {createUseStyles} from "react-jss";
import PropTypes from "prop-types";

const UILineSkeleton = ({className, width, height, ...props}) => {
  const classes = useStyles({width, height});

  return (
    <div className={cn(classes.root, className)} {...props}>
      <span className={classes.inner}>...</span>
    </div>
  )
};

UILineSkeleton.propTypes = {
  width: PropTypes.any.isRequired,
};

export {UILineSkeleton};

const useStyles = createUseStyles({
  '@keyframes uiLineSkeleton': {
    '100%': {
      backgroundPositionX: 0,
    }
  },

  root: ({width, height}) => ({
    display: 'inline-block',
    background: 'linear-gradient(90deg, #eee 0%, #f5f5f5 50%, #eee 100%)',
    userSelect: 'none',
    backgroundSize: '100%',
    backgroundRepeat: 'repeat-x',
    borderRadius: 4,
    backgroundPositionX: -width,
    animationName: '$uiLineSkeleton',
    animationDuration: '1s',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'ease-in-out',
    lineHeight: 1,
    width: width,
    height: height || 'auto',
  }),

  inner: {
    display: 'block',
    width: 0,
    color: 'transparent',
    overflow: 'hidden',
  }
});
